import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-end" data-id="element-60">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-61">
        <img src="https://cdn.magicpatterns.com/uploads/do8fwrMG9viYTf5E8ULbF8/cortinas_hero_img.png" alt="Sala de estar de lujo con cortinas elegantes y cojines dorados" className="w-full h-full object-cover" data-id="element-62" />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C1C] via-[#1C1C1C]/60 to-transparent" data-id="element-63" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-5 md:px-12 lg:px-20 pb-16 md:pb-24 pt-32" data-id="element-64">
        <div className="max-w-4xl" data-id="element-65">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-66">
            <span className="inline-block py-1.5 px-4 bg-[#C9A96E] text-[#1C1C1C] text-xs tracking-[0.25em] uppercase mb-6 font-semibold" data-id="element-67">
              El Método Perfect-Hang
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-[1.15] mb-6" data-id="element-68">
            Cómo Lograr que tu Hogar Luzca como una{' '}
            <span className="italic text-[#C9A96E]" data-id="element-69">Mansión de Revista</span>{' '}
            usando tu Máquina de Coser Casera{' '}
            <span className="text-white/70" data-id="element-70">(y Telas de $5 el Metro)</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="text-base md:text-xl text-white/80 font-light max-w-2xl mb-10 leading-relaxed" data-id="element-71">
            Aprende el{' '}
            <span className="text-[#C9A96E] font-medium" data-id="element-72">
              "Método Perfect-Hang"
            </span>
            : El secreto de los decoradores de Beverly Hills para cortinas y
            cojines de lujo que NADIE creerá que hiciste tú misma.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-73">
            <a href="#precio" onClick={e => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group bg-[#C9A96E] text-[#1C1C1C] px-8 py-4 text-base font-semibold tracking-wide hover:bg-white transition-colors duration-300 flex items-center gap-3" data-id="element-74">
              Quiero el Método
              <ArrowDownIcon className="w-4 h-4 group-hover:translate-y-1 transition-transform" data-id="element-75" />
            </a>
            <span className="text-sm text-white/50 italic font-serif" data-id="element-76">
              Sin máquina industrial. Sin experiencia previa.
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}